'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { ContentBrowser } from '@/components/content/ContentBrowser';
const FEATURED_NEWS_TYPES = ['news', 'article'];
const FEATURED_NEWS_TAG = 'Featured';
export function FeaturedNewsSection() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-8"><h2 className="text-3xl font-bold text-gray-900">News</h2></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: FEATURED_NEWS_TYPES,
      status: "published",
      visibility: "public",
      tags: [FEATURED_NEWS_TAG]
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ContentBrowser query={t1} limit={6} searchEnabled={false} showFilters={false} showResultCount={false} showViewModeToggle={false} hideHeaderOnEmpty={true} minHeight="none" mobileColumns={1} scrollOnChange={false} emptyState={{
      title: "No featured news",
      description: "",
      compact: true
    }} cardProps={{
      variant: "default",
      showTypeBadge: true,
      showTags: false,
      showImage: false
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-16"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t0}{t2}<div className="mt-10 text-center"><Link href="/content?type=news" className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-[#ff5a36] px-7 py-3.5 text-base font-black text-white shadow-lg shadow-red-500/20 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-500/30">View All News<ArrowRight className="h-4 w-4" aria-hidden="true" /></Link></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}